var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallicompSemNome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGOCALICOMP",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 836 836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke-width: 2px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        fill: url(#Gradiente_sem_nome_29);\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke-width: 12px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_29",
    "data-name": "Gradiente sem nome 29",
    x1: 152.63,
    y1: 186.75,
    x2: 782.91,
    y2: 735.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad3d77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a53c77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#923c79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#863c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#5f3980"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Frame",
    className: "cls-4",
    cx: 418,
    cy: 418,
    r: 418
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Liga\\xE7\\xF5es"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 340.42,
    cy: 144.08,
    r: 33.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 660.25,
    cy: 220.08,
    r: 33.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 669.75,
    cy: 527.25,
    r: 33.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 482.92,
    cy: 669.75,
    r: 33.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 166.25,
    cy: 511.42,
    r: 33.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 342,
    y1: 142.5,
    x2: 167.83,
    y2: 509.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 660.25,
    y1: 220.08,
    x2: 166.25,
    y2: 511.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 343.58,
    y1: 140.92,
    x2: 482.92,
    y2: 669.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 166.25,
    y1: 511.42,
    x2: 482.92,
    y2: 679.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 669.75,
    y1: 527.25,
    x2: 482.92,
    y2: 669.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 166.25,
    y1: 511.42,
    x2: 669.75,
    y2: 527.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 660.25,
    y1: 220.08,
    x2: 669.75,
    y2: 527.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 343.58,
    y1: 144.08,
    x2: 660.25,
    y2: 220.08
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallicompSemNome);
export default __webpack_public_path__ + "static/media/callicompSemNome.939755ab08c8396f0ca117ce630c0d59.svg";
export { ForwardRef as ReactComponent };